import { featureRoute } from '../helpers';
import { OtherTicketStages } from '../../constants/AppConstants';

export default featureRoute('enableOtherTickets', OtherTicketStages.SEARCH, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/otherTicket/Search').default);
        }, 'othertickets');
    }
});
